import ReactPaginate from "react-paginate";
import "./pagination.scss";
import { useState } from "react";

interface PaginationProps {
  pageCount: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({ pageCount, onPageChange }: PaginationProps) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (selectedItem: { selected: number }) => {
    onPageChange(selectedItem.selected);
  };

  return (
    <ReactPaginate
      previousLabel={<span className="icon icon-arrow-left"></span>}
      nextLabel={<span className="icon icon-arrow-right"></span>}
      breakLabel="..."
      pageCount={pageCount}
      forcePage={page}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      onPageChange={handlePageChange}
      containerClassName="pagination"
      activeClassName="active"
      breakClassName="break"
      disabledClassName="disabled"
    />
  );
};

export default Pagination;
